/* ═══════════════════════════════════════════════════════════════════════════
   flats-funnel.js — окно-воронка в правой колонке витрины квартир ГОРОДА.
   Префикс zkw-. Пара к /css/flats-funnel.css (запись в public/flats.php).

   Перенос черновика tools/.hero-draft/zadacha-kviz-voronka.js (20-21.08.2026).

   Владелец 20.08, после трёх промахов подряд: «сделай в точности такой же, как
   на скрине, чтоб поменьше размером и компактней, в том же месте». На снимке —
   окно брони с карточки ЖК (#zboWin): слева фото с названием и ценой плюс три
   обещания, справа шаг с полосой, вопрос «Какую квартиру ищете?», подсказка,
   пять вариантов и кнопка «Позвонить».

   ⛔ ЭТО НЕ КОПИЯ ОКНА, А ЕГО ВСТРОЕННАЯ ВЕРСИЯ. Само окно живёт на карточке
      ЖК, строится в body и открывается кнопкой брони — на витрине города такой
      кнопки нет, а его код наружу не выведен. Поэтому повторяем разметку и
      шаги, но данные берём со СВОЕЙ страницы.

   ⛔ ФОТО — НАСТОЯЩИЕ, А НЕ ВЗЯТЫЕ У ОДНОГО ДОМА. На витрине ГОРОДА нет
      конкретного ЖК, и ставить фото первого попавшегося значит выдавать один
      дом за все. Берём по одному кадру у десяти комплексов города.

   ⛔ Заявка уходит тем же путём, что у квиза подбора: POST /bookings.php
      action=create с ловушкой для роботов и меткой источника из белого списка
      обработчика. Своего канала не заводим.

   ⛔ СБОРКА СИНХРОННАЯ, БЕЗ ОЖИДАНИЯ DOMContentLoaded, И ЭТО НЕ ЛЕНЬ.
      Блок превращает контейнер карточек в сетку из двух колонок — то есть
      меняет ширину всей выдачи. Сделай мы это после первой отрисовки, страница
      прыгнула бы на глазах (в каталоге такой прыжок вырос в 37 раз). Файл
      подключён с `defer`: к моменту исполнения разметка разобрана целиком, а
      первой отрисовки ещё не было. Оба нужных узла — `#flatsGrid` и контейнер
      секции — стоят в шаблоне, а не появляются от ответа сервера.
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  // Только витрина квартир города: #flatsGrid есть лишь на flats.php,
  // building_id выдаёт страницу одного дома — там своя форма брони.
  const grid = document.getElementById('flatsGrid');
  const host = document.querySelector('.flats-cards-section > .container');
  if (!grid || !host) return;
  if (window.BRONI_FLATS_BUILDING_ID) return;
  if (window.__broniFlatsFunnel) return;
  if (document.querySelector('.zkw-box')) return;
  window.__broniFlatsFunnel = true;

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const ico = (name) => {
    const i = document.createElement('i');
    i.className = 'fa-solid ' + name;
    i.setAttribute('aria-hidden', 'true');
    return i;
  };

  const CITY = String(window.BRONI_FLATS_CITY || '');

  /* ⛔ ГОРОД В РОДИТЕЛЬНОМ БЕРЁМ У СЕРВЕРА, А НЕ ВЫСКРЕБАЕМ ИЗ ЗАГОЛОВКА.
     Черновик читал H1 регуляркой «новостройках (…)». Работало ровно до тех
     пор, пока в шаблоне перед `<br>` стоит пробел: `textContent` тегов не
     видит, и «новостройках<br>Краснодара» слиплось бы в одно слово, а подпись
     молча стала бы пустой. Между тем сервер УЖЕ печатает склонения всех
     городов в `window.__FLATS_CITIES__` — тем же реестром, которым подписана
     сама страница. Берём ссылку на источник, а не отрисованный результат.
     H1 остаётся запасным путём, кнопка фильтра — третьим. */
  const cityGen = () => {
    const reg = window.__FLATS_CITIES__;
    const row = (reg && CITY) ? reg[CITY] : null;
    if (row && row.gen) return String(row.gen);
    const h1 = document.querySelector('h1');
    const m = h1 && /новостройках\s+(.+?)\s*$/i.exec(h1.textContent.replace(/\s+/g, ' ').trim());
    if (m) return m[1].trim();
    const c = document.querySelector('.flats-city-filter__name');
    return c ? c.textContent.trim() : '';
  };
  const cityName = cityGen();
  const heading = cityName ? ('Новостройки ' + cityName) : 'Новостройки';

  // Цена «от» — из строки-сводки под заголовком. Её пишет сайтовый скрипт по
  // ответу сервера, то есть это настоящий минимум по городу, а не наша догадка.
  const priceFrom = () => {
    const n = document.getElementById('statPriceFrom');
    const t = n ? n.textContent.trim() : '';
    return (t && t !== '—') ? t : '';
  };

  const PERKS = [
    { i: 'fa-lock', t: 'Цену фиксируем в день заявки' },
    { i: 'fa-handshake', t: 'Без комиссии — платит застройщик' },
    { i: 'fa-file-signature', t: 'Бронь и сделка онлайн' },
  ];

  const STEPS = [
    {
      q: 'Какую квартиру ищете?',
      hint: 'Одно нажатие — и дальше. Покажем только то, что реально свободно.',
      grid: true,
      opts: [
        { v: 'Студия', i: 'fa-table-cells-large' },
        { v: '1 комната', i: 'fa-bed' },
        { v: '2 комнаты', i: 'fa-couch' },
        { v: '3 и больше', i: 'fa-house' },
      ],
    },
    {
      q: 'Как планируете оплату?',
      hint: 'От этого зависит и цена, и что мы посчитаем к звонку.',
      opts: [
        { v: 'Ипотека', i: 'fa-percent' },
        { v: 'Полная оплата', i: 'fa-wallet' },
        { v: 'Рассрочка', i: 'fa-calendar-days' },
        { v: 'Материнский капитал', i: 'fa-gift' },
        { v: 'Пока не решил', i: 'fa-comments' },
      ],
    },
    {
      q: 'Когда планируете заехать?',
      hint: 'Подскажем, что уже сдано, а что ещё строится.',
      opts: [
        { v: 'Уже сдан', i: 'fa-key' },
        { v: 'В 2026 году', i: 'fa-calendar-check' },
        { v: 'В 2027 и позже', i: 'fa-helmet-safety' },
        { v: 'Срок не важен', i: 'fa-clock' },
      ],
    },
  ];

  const state = { at: 0, answers: [] };

  /* ── Отправка заявки ──────────────────────────────────────────────────────
     ⛔ ЛОВУШКА ДЛЯ РОБОТОВ (_hp) ОБЯЗАТЕЛЬНА: обработчик заявок сверяет её и
        источник запроса ВМЕСТО CSRF-токена (checkPublicForm в app/security.php).
        Поле есть в разметке, но спрятано от человека — заполняет его только
        робот, и такая заявка отсекается.
     ⛔ ГАЛОЧКА СОГЛАСИЯ — НЕ ФОРМАЛЬНОСТЬ. Заявка без согласия на обработку
        данных нарушает 152-ФЗ, поэтому без неё отправка не идёт.
     ⛔ Код источника берём из белого списка обработчика ('podbor'/'luchshie'/
        'selection', public/bookings.php:44). Свой код молча схлопнулся бы в
        пустой, и лид потерял бы канал.                                       */
  const digits = (v) => String(v || '').replace(/\D+/g, '');

  const maskPhone = (raw) => {
    let d = digits(raw);
    if (!d) return '';
    if (d[0] === '8') d = '7' + d.slice(1);
    if (d[0] !== '7') d = '7' + d;
    d = d.slice(0, 11);
    let out = '+7';
    if (d.length > 1) out += ' (' + d.slice(1, 4);
    if (d.length >= 4) out += ')';
    if (d.length > 4) out += ' ' + d.slice(4, 7);
    if (d.length > 7) out += '-' + d.slice(7, 9);
    if (d.length > 9) out += '-' + d.slice(9, 11);
    return out;
  };

  const makeConsent = () => {
    const cons = el('label', 'zkw-consent');
    const inp = document.createElement('input');
    inp.type = 'checkbox';
    inp.className = 'zkw-consent__i';
    cons.appendChild(inp);
    cons.appendChild(el('span', 'zkw-consent__box'));
    const txt = el('span', 'zkw-consent__t');
    txt.appendChild(el('span', null, 'Согласен на обработку персональных данных, '));
    const link = el('a', null, 'условия');
    link.href = '/soglasie.php';
    link.target = '_blank';
    link.rel = 'noopener';
    link.addEventListener('click', (e) => e.stopPropagation());
    txt.appendChild(link);
    cons.appendChild(txt);
    return { node: cons, input: inp };
  };

  const send = (payload, form, btn, msg) => {
    btn.disabled = true;
    msg.hidden = false;
    msg.classList.remove('zkw-msg--ok');
    msg.textContent = 'Отправляем…';
    fetch('/bookings.php?action=create', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json().catch(() => null))
      .then((data) => {
        if (data && data.ok) {
          msg.textContent = 'Заявка принята — перезвоним в рабочее время.';
          msg.classList.add('zkw-msg--ok');
          form.querySelectorAll('input, button').forEach((n) => { n.disabled = true; });
        } else {
          btn.disabled = false;
          msg.textContent = (data && data.error) || 'Не получилось отправить. Попробуйте ещё раз.';
        }
      })
      .catch(() => {
        btn.disabled = false;
        msg.textContent = 'Не получилось отправить. Проверьте связь и попробуйте ещё раз.';
      });
  };

  const buildForm = (opts) => {
    const form = el('form', 'zkw-form' + (opts.compact ? ' zkw-form--compact' : ''));
    form.noValidate = true;

    const hp = document.createElement('input');
    hp.type = 'text';
    hp.className = 'zkw-hp';
    hp.tabIndex = -1;
    hp.setAttribute('aria-hidden', 'true');
    hp.autocomplete = 'off';
    form.appendChild(hp);

    let nameInp = null;
    if (!opts.compact) {
      const nw = el('label', 'zkw-field');
      nw.appendChild(el('span', 'zkw-label', 'Ваше имя'));
      nameInp = document.createElement('input');
      nameInp.type = 'text';
      // ym-hide-content — Метрика не должна писать ПДн в Вебвизор.
      nameInp.className = 'zkw-input ym-hide-content';
      nameInp.placeholder = 'Как к вам обращаться';
      nameInp.autocomplete = 'name';
      nw.appendChild(nameInp);
      form.appendChild(nw);
    }

    const pw = el('label', 'zkw-field');
    if (!opts.compact) pw.appendChild(el('span', 'zkw-label', 'Телефон'));
    const phone = document.createElement('input');
    phone.type = 'tel';
    phone.className = 'zkw-input ym-hide-content';
    phone.placeholder = '+7 (___) ___-__-__';
    phone.autocomplete = 'tel';
    phone.inputMode = 'tel';
    phone.addEventListener('input', () => { phone.value = maskPhone(phone.value); });
    pw.appendChild(phone);
    form.appendChild(pw);

    const cons = makeConsent();
    form.appendChild(cons.node);

    const btn = el('button', 'zkw-call');
    btn.type = 'submit';
    btn.appendChild(ico(opts.icon || 'fa-paper-plane'));
    btn.appendChild(el('span', null, opts.label || 'Получить подборку'));
    form.appendChild(btn);

    const msg = el('p', 'zkw-msg');
    msg.hidden = true;
    form.appendChild(msg);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (hp.value) return;                       // робот
      // 11 цифр — это +7 и десять цифр номера. Меньше — номер недобран.
      if (digits(phone.value).length < 11) {
        msg.hidden = false;
        msg.classList.remove('zkw-msg--ok');
        msg.textContent = 'Введите номер телефона полностью.';
        phone.focus();
        return;
      }
      if (!cons.input.checked) {
        msg.hidden = false;
        msg.classList.remove('zkw-msg--ok');
        msg.textContent = 'Отметьте согласие на обработку данных — без него не сможем перезвонить.';
        cons.input.focus();
        return;
      }
      const answered = state.answers.filter(Boolean);
      send({
        action: 'create',
        name: nameInp ? nameInp.value.trim() : '',
        phone: phone.value.trim(),
        city: CITY,
        consent_main: '1',
        notes: opts.notesHead
          + (cityName ? ' (' + cityName + ')' : '')
          + (answered.length ? ': ' + answered.join(' · ') : ''),
        _hp: '',
        _source: 'selection',
      }, form, btn, msg);
    });

    return form;
  };

  // ── левая половина: лента фото + название и цена ──
  const buildAside = () => {
    const aside = el('aside', 'zkw-aside');
    const gal = el('div', 'zkw-gal');
    const img = el('img', 'zkw-gal-img');
    img.decoding = 'async';
    img.loading = 'lazy';
    img.alt = heading;
    gal.appendChild(img);

    const cap = el('div', 'zkw-cap');
    cap.appendChild(el('div', 'zkw-cap-ttl', heading));
    /* ⛔ ЦЕНА ПРИХОДИТ ПОЗЖЕ НАС. Её пишет сайтовый скрипт после ответа
       сервера: на момент сборки блока в узле стоит «—». Первый заход это и
       поймал — плашки цены не было вовсе, хотя на странице она уже висела.
       Поэтому рисуем плашку сразу, а значение подставляем, когда приедет. */
    const badge = el('div', 'zkw-cap-price');
    badge.hidden = true;
    badge.appendChild(el('span', 'zkw-cap-price__from', 'от'));
    const priceVal = el('span', null, '');
    badge.appendChild(priceVal);
    cap.appendChild(badge);

    const setPrice = () => {
      const p = priceFrom();
      if (!p) return false;
      priceVal.textContent = p;
      badge.hidden = false;
      return true;
    };
    if (!setPrice()) {
      const node = document.getElementById('statPriceFrom');
      if (node) {
        const w = new MutationObserver(() => { if (setPrice()) w.disconnect(); });
        w.observe(node, { childList: true, characterData: true, subtree: true });
        window.setTimeout(() => w.disconnect(), 20000);
      }
    }
    gal.appendChild(cap);
    aside.appendChild(gal);

    const perks = el('ul', 'zkw-perks');
    PERKS.forEach((x) => {
      const li = el('li', 'zkw-perk');
      li.appendChild(ico(x.i));
      li.appendChild(el('span', null, x.t));
      perks.appendChild(li);
    });
    aside.appendChild(perks);

    /* ⛔ ФОТО БЕРЁМ У КАРТЫ, А НЕ У ВЫПАДАШКИ. В выпадашке кадры заказаны
       шириной 96 px — это значок в строке списка; растянутый на 340 px он
       мыльный, что владелец и увидел. Ручка карты отдаёт полноразмерные
       снимки комплексов города, и их можно попросить через сайтовый
       уменьшитель любой ширины.
       ⛔ У каждого ГОРОДА свои дома: слаг подставляем со страницы, ничего не
       зашиваем. Берём по одному кадру у десяти комплексов — это витрина
       города, а не галерея одного дома.
       ⛔ Слаг из BRONI_FLATS_CITY — это ОСЬ витрины, а не городской столбец
       базы: у подмосковных страниц он `podmoskovye`, и карта понимает именно
       его (у карточки дома пришлось брать ось из адреса — там переменная
       приходит из базы и на 28 домах Подмосковья равна `moscow`). */
    const thumb = (src, w) => {
      if (!src || !/^https?:\/\//i.test(src)) return src || '';
      return '/img-thumb.php?src=' + encodeURIComponent(src) + '&w=' + w;
    };

    const shots = [];
    let cur = 0;

    const show = (i) => {
      if (!shots.length) return;
      cur = (i + shots.length) % shots.length;
      img.src = shots[cur];
    };

    const runBelt = () => {
      show(0);
      gal.classList.add('zkw-gal--on');
      // Кадр меняется раз в 5 секунд и только когда вкладка открыта: крутить
      // ленту в фоне значит зря греть сеть и батарею.
      window.setInterval(() => { if (!document.hidden) show(cur + 1); }, 5000);
    };

    if (CITY) {
      // `fields=card`: лента кадров собирается из `photos` — они есть только здесь
      // и в умолчании; профиль `map` оставил бы ленту пустой.
      fetch('/map_api.php?action=list&city=' + encodeURIComponent(CITY) + '&limit=10&fields=card',
            { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          const items = (data && Array.isArray(data.items)) ? data.items : [];
          items.forEach((it) => {
            let list = it && it.photos;
            // Поле приходит строкой с JSON внутри — разбираем аккуратно и
            // молча пропускаем дом, если разобрать не вышло.
            if (typeof list === 'string') {
              try { list = JSON.parse(list); } catch (err) { list = null; }
            }
            if (Array.isArray(list) && list.length) {
              const u = thumb(String(list[0]), 900);
              if (u) shots.push(u);
            }
          });
          if (shots.length) runBelt();
        })
        .catch(() => {});
    }

    return aside;
  };

  // ── правая половина: шаги ──
  const main = el('div', 'zkw-main');
  const head = el('div', 'zkw-head');
  const headRow = el('div', 'zkw-headrow');
  const backBtn = el('button', 'zkw-back');
  backBtn.type = 'button';
  backBtn.appendChild(ico('fa-chevron-left'));
  backBtn.appendChild(el('span', null, 'Назад'));
  const countEl = el('div', 'zkw-count');
  headRow.appendChild(backBtn);
  headRow.appendChild(countEl);
  head.appendChild(headRow);
  const track = el('div', 'zkw-track');
  const fill = el('div', 'zkw-fill');
  track.appendChild(fill);
  head.appendChild(track);
  main.appendChild(head);

  const body = el('div', 'zkw-body');
  main.appendChild(body);

  const foot = el('div', 'zkw-foot');
  const callBtn = el('button', 'zkw-call');
  callBtn.type = 'button';
  callBtn.appendChild(ico('fa-phone'));
  callBtn.appendChild(el('span', null, 'Позвонить'));
  const note = el('p', 'zkw-note',
    'Отвечаем в рабочее время. Номер используем только для этой заявки.');
  foot.appendChild(callBtn);
  foot.appendChild(note);
  main.appendChild(foot);

  const total = STEPS.length + 1;   // шаги + контакт

  const renderStep = (i) => {
    body.textContent = '';
    const cfg = STEPS[i];
    if (!cfg) return;
    body.appendChild(el('h3', 'zkw-q', cfg.q));
    if (cfg.hint) body.appendChild(el('p', 'zkw-hint', cfg.hint));
    const opts = el('div', 'zkw-opts' + (cfg.grid ? ' zkw-opts--grid' : ''));
    cfg.opts.forEach((o) => {
      const b = el('button', 'zkw-opt' + (o.wide ? ' zkw-opt--wide' : ''));
      b.type = 'button';
      const iw = el('span', 'zkw-opt__ico');
      iw.appendChild(ico(o.i));
      b.appendChild(iw);
      b.appendChild(el('span', 'zkw-opt__ttl', o.v));
      b.addEventListener('click', () => {
        state.answers[i] = o.v;
        go(i + 1);
      });
      opts.appendChild(b);
    });
    body.appendChild(opts);

    /* ⛔ НА ПЕРВОМ ШАГЕ ВМЕСТО «ЕЩЁ ВЫБИРАЮ» — СРАЗУ ТЕЛЕФОН. Владелец 20.08:
       «сделай по умолчанию вместо "ещё выбираю" строку под номер телефона и
       галочку — вдруг кто-то просто захочет оставить заявку, не проходя квиз».
       Логика верная: «ещё выбираю» вело на второй вопрос, то есть отвечало на
       нежелание отвечать ещё одним вопросом. Теперь человек, который не хочет
       квиза, оставляет номер в два касания и уходит.
       ⛔ Это НЕ то «Ещё выбираю», которое владелец вернул в окно брони на
       карточке ЖК: там кнопка осталась, здесь её не было изначально. */
    if (i === 0) {
      const quick = el('div', 'zkw-quick');
      quick.appendChild(el('div', 'zkw-quick-t', 'Или просто оставьте номер — подберём сами'));
      quick.appendChild(buildForm({
        compact: true,
        icon: 'fa-phone',
        label: 'Оставить заявку',
        notesHead: 'Заявка без квиза, витрина квартир',
      }));
      body.appendChild(quick);
    }
  };

  const renderContact = () => {
    body.textContent = '';
    body.appendChild(el('h3', 'zkw-q', 'Куда прислать подборку?'));
    body.appendChild(el('p', 'zkw-hint', 'Позвоним и пришлём варианты под ваш запрос.'));
    const sum = el('div', 'zkw-sum');
    state.answers.filter(Boolean).forEach((a) => sum.appendChild(el('span', 'zkw-chip', a)));
    if (sum.children.length) body.appendChild(sum);
    body.appendChild(buildForm({
      compact: false,
      label: 'Получить подборку',
      notesHead: 'Квиз витрины квартир',
    }));
  };

  function go(i) {
    state.at = Math.max(0, Math.min(i, STEPS.length));
    if (state.at < STEPS.length) renderStep(state.at); else renderContact();
    countEl.textContent = 'ШАГ ' + (state.at + 1) + ' / ' + total;
    fill.style.width = Math.round((state.at + 1) / total * 100) + '%';
    backBtn.hidden = state.at === 0;
    /* Нижнюю кнопку прячем там, где рядом уже стоит форма: на первом шаге —
       короткая заявка, на последнем — полная. Две кнопки к одному действию в
       двух сантиметрах друг от друга заставляют выбирать, чем пользоваться;
       это ровно то, за что владелец сегодня уже отчитал на чипах комнатности. */
    foot.hidden = state.at >= STEPS.length || state.at === 0;
  }

  backBtn.addEventListener('click', () => go(state.at - 1));
  callBtn.addEventListener('click', () => go(STEPS.length));

  // ── сборка ──
  const box = el('div', 'zkw-box');
  box.appendChild(buildAside());
  box.appendChild(main);

  const wrap = el('div', 'zkw-wrap');
  wrap.appendChild(box);

  host.classList.add('zkw-host');
  host.appendChild(wrap);
  go(0);
})();
